/**
 * Implement Gatsby's Browser APIs in this file.
 *
 * See: https://www.gatsbyjs.org/docs/browser-apis/
 */

// You can delete this file if you're not using it
require("prismjs/themes/prism-tomorrow.css")
import "@fontsource/inter"
import "@fontsource/jetbrains-mono"
import "@fontsource/outfit"
